import React from "react";
import { checkIsEmployed } from "../../services/Utils";

const DynamicCheckbox = ({
  id,
  name,
  label,
  disabled,
  setHasOwnBusiness,
  setIsEmployed,
  checked,
  updateItems,
  selectedOccupations,
}) => {
  const handleCheck = (e) => {
    let id = e.target.id;
    updateItems(id, e.target.checked);

    if (id == 60) {
      setHasOwnBusiness(e.target.checked);
    }
    if (id == 59 || id == 60 || id == 61) {
      if (!e.target.checked) {
        setIsEmployed(checkIsEmployed(selectedOccupations, [59, 60, 61]));
      } else {
        setIsEmployed(e.target.checked);
      }
    }
  };

  return (
    <div className="bx--form-item bx--checkbox-wrapper">
      <input
        type="checkbox"
        id={id}
        name={name}
        className="bx--checkbox"
        disabled={disabled}
        defaultChecked={checked}
        onClick={handleCheck}
      />
      <label htmlFor={id} className="bx--checkbox-label">
        <span className="bx--checkbox-label-text">{label}</span>
      </label>
    </div>
  );
};

DynamicCheckbox.defaultProps = {
  disabled: false,
  checked: false,
};
export default DynamicCheckbox;
